import React from "react";
import { useNavigate, useOutletContext } from "react-router";
import { SmProductsContainer } from "../../styled/simpleTheme";

const defaultItems = Array.from({ length: 4 }, () => ({
  label: "상품",
  img: "/img/products.png",
}));

const smProducts15922 = [
  { name: "키오스크" },
  { name: "포스" },
  { name: "신용카드단말기" },
  { name: "테이블오더" },
];

const SmProducts = ({ products }) => {
  const navigate = useNavigate();
  const { cmpnyNo, url } = useOutletContext();

  const isSm = cmpnyNo === 15922;
  const data = isSm ? smProducts15922 : products?.length > 0 ? products : defaultItems;

  return (
    <SmProductsContainer>
      <div className="label">
        {isSm ? (
          <>
            <span>나에게 맞는 결제 방식으로</span>
            <span className="description">
              갓 사업을 시작하신 사장님들을 위한
              <br />
              맞춤형 포스기를 추천드려요
              <br /> 원하는대로 나만의 가게를 꾸려보세요!
            </span>
          </>
        ) : null}
      </div>
      <ul>
        {data.slice(0, 4).map((item, idx) => (
          <li key={idx} className="box" onClick={() => navigate(`/shop/${url}/productsList`)}>
            <img
              src={
                isSm
                  ? `/img/shopTheme/sm_prd_${idx}.png`
                  : item.media?.[0]
                  ? imgHandler(item.media)
                  : "/img/application_price_1.png"
              }
              alt=""
            />
            <span>{item.name || item.label}</span>
          </li>
        ))}
      </ul>
    </SmProductsContainer>
  );
};

export default SmProducts;
